// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d597941","455":"9fbccdcd","977":"95073307"}[chunkId] + ".chunk.js";
};